import React, { useMemo } from "react";
import { FaTrophy } from "react-icons/fa";

import BracketHeader from "./tableauElimination/BracketHeader";
import BracketLegend from "./tableauElimination/BracketLegend";
import BracketBoard from "./tableauElimination/BracketBoard";

import {
  buildBracketRounds,
  getBracketStats,
} from "./tableauElimination/bracketUtils";

const TableauElimination = ({
  competiteurs = [],
  combats = [],
  roundNames = [],
  onOpenCreate,
  onOpenEdit,
  onOpenScoreboard,
  firstRoundSeed = [],
}) => {
  const seed =
    Array.isArray(firstRoundSeed) && firstRoundSeed.length
      ? firstRoundSeed
      : competiteurs;

  const rounds = useMemo(
    () =>
      buildBracketRounds({
        seed,
        competiteurs,
        combats,
        roundNames,
      }),
    [seed, competiteurs, combats, roundNames],
  );

  const stats = useMemo(() => getBracketStats(seed, rounds), [seed, rounds]);

  if (!rounds.length) {
    return (
      <div className="mx-auto mt-10 max-w-4xl rounded-[2rem] border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-white/10 dark:bg-slate-950">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-300">
          <FaTrophy />
        </div>

        <h3 className="text-lg font-bold text-slate-900 dark:text-white">
          Tableau indisponible
        </h3>

        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
          Il faut au moins deux combattants pour générer un tableau.
        </p>
      </div>
    );
  }

  return (
    <section className="mt-8 w-full">
      <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_18px_55px_rgba(15,23,42,0.08)] dark:border-white/10 dark:bg-slate-950">
        <BracketHeader stats={stats} />

        <BracketLegend />

        <BracketBoard
          seed={seed}
          rounds={rounds}
          onOpenCreate={onOpenCreate}
          onOpenEdit={onOpenEdit}
          onOpenScoreboard={onOpenScoreboard}
        />
      </div>
    </section>
  );
};

export default TableauElimination;